import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CookieNotice } from "@/components/site/CookieNotice";
import { usePageMeta } from "@/lib/pageMeta";
import PricingCalculatorPage from "@/pages/PricingCalculatorPage";
import VerifyQuotePage from "@/pages/VerifyQuotePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import BookkeepingFeesPage from "@/pages/BookkeepingFeesPage";
import FinancialStatementFeesPage from "@/pages/FinancialStatementFeesPage";
import AuditReviewFeesPage from "@/pages/AuditReviewFeesPage";
import OutsourcedFinancialManagementPage from "@/pages/OutsourcedFinancialManagementPage";

/** Sits inside the router so it can follow route changes. */
const RoutedPages = () => {
  usePageMeta();

  return (
    <Routes>
      <Route path="/" element={<PricingCalculatorPage />} />
      <Route path="/pricing-calculator" element={<PricingCalculatorPage />} />
      <Route path="/bookkeeping-fees" element={<BookkeepingFeesPage />} />
      <Route path="/financial-statement-fees" element={<FinancialStatementFeesPage />} />
      <Route path="/audit-review-fees" element={<AuditReviewFeesPage />} />
      <Route
        path="/outsourced-financial-management"
        element={<OutsourcedFinancialManagementPage />}
      />
      <Route path="/verify-quote" element={<VerifyQuotePage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminDashboardPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <RoutedPages />
      <CookieNotice />
      <Toaster position="bottom-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
